/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_PrepareInvoiceEmailRequest = {
    lang?: billing_PrepareInvoiceEmailRequest.lang;
    payer_id?: string;
};
export namespace billing_PrepareInvoiceEmailRequest {
    export enum lang {
        DE = 'de',
        EN = 'en',
        FR = 'fr',
        IT = 'it',
        ES = 'es',
        PT = 'pt',
    }
}

